import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loading from "../../Loading/Loading";

const ViewTab = ({ id = -1 }) => {
  const navigate = useNavigate();

  const [tab, setTab] = useState(null);

  useEffect(() => {
    async function getAccessory(id) {
      const dataRes = await axios.post(process.env.REACT_APP_URL_API_DATA + "/model/tabs/" + id);
      setTab(dataRes.data.success.data);
    }
    if (id !== -1) {
      getAccessory(id);
    }
  }, [id]);

  return (
    <>
      {!tab ? (
        <Loading />
      ) : (
        <div>
          <div style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}>
            <h3 className="px-5">
              {tab.model_name}
              <hr className="" />
            </h3>
          </div>
          <Row>
            <Col
              md={12}
              lg={6}
              className="px-5 pb-2"
              style={{
                width: "100%",
                whiteSpace: "pre-line",
                wordBreak: "break-word",
              }}
            >
              <strong>Brand:</strong> {tab.brand_name}
            </Col>
            <Col
              md={12}
              lg={6}
              className="px-5 pb-2"
              style={{
                width: "100%",
                whiteSpace: "pre-line",
                wordBreak: "break-word",
              }}
            >
              <strong>Title:</strong> {tab.title}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Processor:</strong> {tab.processor}
            </Col>
            <Col
              md={12}
              lg={6}
              className="px-5 pb-2"
              style={{
                width: "100%",
                whiteSpace: "pre-line",
                wordBreak: "break-word",
              }}
            >
              <strong>Colors:</strong>{" "}
              {tab.colors_available.map((color, index) => (
                <span key={index} className="bg-light text-dark mx-2 shadow-sm">
                  {color.label}
                </span>
              ))}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>RAM:</strong> {tab.ram + " GB"}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Storage:</strong> {tab.storage + " GB"}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Resolution:</strong> {tab.resolution}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Refresh Rate:</strong> {`${tab.refresh_rate} Hz`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Screen Size:</strong> {`${tab.screen_size} inches`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Screen Type:</strong> {`${tab.screen_type}`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Screen Protection:</strong> {`${tab.screen_protection}`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Speaker:</strong> {`${tab.speaker}`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Battery Capacity:</strong> {`${tab.battery_capacity} mAh`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Camera:</strong> {`${tab.camera_specs} MP`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Finger Print:</strong> {`${tab.finger_print}`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>Body Type:</strong> {`${tab.body_type}`}
            </Col>
            <Col md={12} lg={6} className="px-5 pb-2">
              <strong>SIM Support:</strong> {`${tab.sim_support === 1 ? "Yes" : "No"}`}
            </Col>
            {tab.sim_support === 1 ? (
              <>
                <Col md={12} lg={6} className="px-5 pb-2">
                  <strong>SIM type:</strong> {`${tab.sim_type}`}
                </Col>
                <Col md={12} lg={6} className="px-5 pb-2">
                  <strong>Network Bands:</strong> {`${tab.network_bands}`}
                </Col>
                <Col md={12} lg={6} className="px-5 pb-2">
                  <strong>E-Sim:</strong> {`${tab.e_sim === 1 ? "Yes" : "No"}`}
                </Col>
              </>
            ) : (
              ""
            )}
            <Col md={12} lg={6} className="px-5 pb-2" style={{ width: "100%" }}>
              <strong>Port:</strong> <span className="bg-light text-dark mx-2 shadow-sm">{tab.ports}</span>
            </Col>
            <Col md={12} lg={12} className="px-5 pb-2">
              <strong>Description:</strong>
              <div className="border rounded p-3" dangerouslySetInnerHTML={{ __html: tab.description }} />
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default ViewTab;
